let en = {
  translations: {
    "Birthday omen": "Birthday omen",
    Horoscope: "Horoscope",
    Palm: "Palm",
    Coffee: "Coffee",
    Tarot: "Tarot",
    "Animal Spirit": "Animal Spirit",
    WhichAnimal: "WHICH ANIMAL ARE YOU?",
    errorOccured: "An error occured. Please try again.",
    myFortune: "Tell me my fortune",
    Animal: "Animal",
    Loading: "Loading...",
    Uploading: "Uploading...",
    CoffeeCupGuide: "Coffee cup reading guideline",
    CoffeeDesc: `Turn the cup over upside-down on the saucer. think about your
                intent and start with take a photo of inside your coffee cup`,
    isNotCup: "The image is not a cup!",
    Start: "Start",
    Upload: "Upload",
    CancelCamera: "Cancel Camera",
    CameraPermission: "Camera permission is denied.",
    AllowPermission: "Please allow permission or upload your photo",
    ChooseBirthday: "Choose the Birthday you want:",
    BestFortune: "Best Fortune Teller",
    StepAwayFortune: "Only a step away from your fortune",
    ContinueGoogle: "Continue with Google",
    FindSecrets: "Find the secrets in your hand",
    isNotPalm: "The image is not a Palm Hand!",
    ScanHand: `By advanced scanning and reading technology, Palm Reader can
               predict your fortune, love, life and many more aspects.`,
    TakePicture: "Take picture",
    DeniedCamera:
      "Camera Permission is denied or You can't use camera on this device",
    PalmReading: "Palm reading",
    Birthday: "Birthday",
    YourIntention: "set your intention, focus on it and let's start",
    AboutUs: `Do you like to know your fortune? The art of divination is important in our everyday life whether we recognize it or not. With Best Fortune Teller you are exactly where you should be! In this application, you can see what the universe has for you for the day, week or month.
None of us can indeed change the past nor the future but we can use the information here to know where we are heading to! In this application you can get your daily horoscope, spirit animal, birthday omen, Tarot, Coffee Cup reading and your Palm reading.`,
AboutUsExtraTitle: "Subscription & Transparency",    
AboutUsExtra: `We are committed to clear and straightforward pricing.
A Premium Membership gives you full access to Best Fortune Teller’s content and tracking features for:
•	8 EGP/day for Etisalat users
•	10 EGP/day for WE users
•	5 EGP/day for Orange users
•	Charges are billed directly through your mobile operator for ease and security
•	Subscription renews automatically on a daily basis
•	By subscribing, you agree to daily charges until you cancel
•	No long-term commitments required
•	You can unsubscribe at any time
To unsubscribe, send the following free SMS:
•	Etisalat users: “UNSUB BFT” to 1722
•	WE users: “UNSUB BFT” to 4041
•	Orange users: “UNSUB BFT” to 5030
`,
    AboutUsTitle: "About Us",
    More: "More",
    Less: "Less",
    PrivacyTitle: "Privacy",
    Privacy: `Privacy Policy
Effective Date: January 2026
This Privacy Policy explains how Best Fortune Teller Egypt (bft-eg.com) collects, uses, and safeguards users’ personal data.
1.	Introduction
Best Fortune Teller Egypt values your privacy and is dedicated to protecting your personal information. This policy outlines how data is collected, used, and shared when you access or subscribe to our premium digital service at bft-eg.com.
Best Fortune Teller Egypt operates as a subscription-based service, charged at 8 EGP/day for Etisalat users and 10 EGP/day for WE users and 5 EGP/day for Orange users, with billing handled through your mobile operator. The subscription renews automatically each day, and by selecting “Subscribe,” you agree to ongoing daily charges until cancellation.
`,
    PrivacyExtra: `
2.	Information We Collect
We may collect the following types of data:
•	Mobile Number:
Your number is obtained from your telecom provider (Etisalat or WE or Orange Egypt) upon subscription confirmation to enable service activation and billing.
•	Personal Information:
Details such as your name or email address when you contact us for support or inquiries.
•	Usage Data:
Technical information including browser type, IP address, device details, and how you interact with our website.
•	Cookies:
Small data files stored on your device to enhance functionality and analyze site performance.
3.	How We Use Your Information
Your information is used to:
•	Activate and manage your subscription
•	Handle billing through your telecom operator
•	Respond to support requests
•	Improve website performance and user experience
•	Meet legal and regulatory requirements
4.	Data Retention
We keep personal data only for as long as needed to deliver the service, manage billing, resolve disputes, and comply with applicable laws.
5.	Data Security
We apply appropriate technical and organizational measures to protect your data from unauthorized access, modification, disclosure, or loss.
6.	Sharing of Information
We do not sell or lease your personal data.
Information may be shared only with:
•	Telecom operators in Egypt (Etisalat or WE or Orange) for service activation and billing
•	Trusted partners who assist in operating the service and are bound by confidentiality obligations
7.	Your Rights
You have the right to:
•	Access the personal data we hold about you
•	Request corrections or deletion of your data
•	Withdraw consent where applicable
•	Cancel your subscription at any time
To exercise these rights, contact us at:
Email: contact@bft-eg.com
8.	Unsubscribe
You can unsubscribe at any time by sending a free SMS:
•	Etisalat users: “UNSUB BFT” to 1722
•	WE users: “UNSUB BFT” to 4041
•	Orange users: “UNSUB BFT” to 5030
9.	International Data Transfers
Your data may be processed in countries where we or our service providers operate. We ensure appropriate safeguards in line with applicable data protection regulations, including the Egypt Personal Data Protection Law (PDPPL).
10.	Policy Updates
This Privacy Policy may be updated periodically. The latest version will always be available on bft-eg.com with the revised effective date.
11.	Contact Us
For any questions regarding this policy, please contact us:
Email: contact@bft-eg.com 
Website: https://bft-eg.com
`,
    TermsTitle: "Terms & Conditions",
    TermsCondition: `Your access to and use of the Service is subject to your acceptance of these Terms and your compliance with them. These Terms apply to all individuals who visit, access, or use the Service. By using the Service, you agree to be bound by these Terms. If you do not agree with any part of them, you should not use the Service. This Service is intended only for users aged 18 and above.`,
    TermsConditionExtra: `Availability, Errors, and Inaccuracies
We regularly update our products and services, which means some content may occasionally be delayed or temporarily unavailable while updates are being made on our platform or in external advertising.
Although we make reasonable efforts to keep the Service accurate and up to date, we do not guarantee the accuracy, completeness, or timeliness of any information. We reserve the right to modify content and correct errors or omissions at any time without prior notice.
Subscriptions
Certain features of the Service are offered on a subscription basis. Best Fortune Teller Egypt is a premium subscription service priced at 8 EGP per day for Etisalat users and 10 EGP per day for WE usersand  5 EGP per day for Orange users.
The subscription renews automatically each day. By selecting “Subscribe,” you agree to daily charges until you cancel. Billing is processed in advance on a recurring daily cycle. Your subscription will automatically renew under the same terms unless cancelled by you or by us.
You may cancel your subscription at any time using the method described below.
Billing and Transaction Processing
As a subscription service, we process billing information related to your account through your mobile network provider (Etisalat or WE or Orange Egypt).
By subscribing, you authorize your operator to deduct the applicable fee from your prepaid balance or include it in your postpaid invoice.
No Long-Term Commitment
There is no long-term obligation. You can cancel your subscription whenever you choose. If you cancel during an active billing period, you will continue to have access until the end of that period. After cancellation, the subscription will not renew, and no further charges will be applied unless you subscribe again.
Except where required by law, refunds or credits for unused time or partial billing periods are generally not provided.
Refund Policy
Refund requests are reviewed individually and may be approved at our discretion, unless otherwise required by applicable law.
Limitation of Liability
Best Fortune Teller Egypt, including its directors, employees, partners, agents, suppliers, and affiliates, shall not be held liable for any indirect, incidental, special, consequential, or punitive damages. This includes, but is not limited to, loss of profits, data, usage, goodwill, or other intangible losses arising from:
1.	Your use of or inability to use the Service
2.	Any third-party actions or content
3.	Unauthorized access to or modification of your data
4.	Any other issues related to the Service
Disclaimer
You use the Service at your own risk. The Service is provided “as is” and “as available,” without any warranties, whether express or implied.
We do not guarantee that:
•	The Service will operate without interruptions or errors
•	Any defects will be fixed
•	The Service will meet your expectations or requirements
Unsubscribe and Withdrawal of Data Processing
You have the right to stop data processing at any time by cancelling your subscription.
To unsubscribe, send a free SMS:
•	Etisalat users: “UNSUB BFT” to 1722
•	WE users: “UNSUB BFT” to 4041
•	Orange users: “UNSUB BFT” to 5030
Once unsubscribed, future billing and any related data processing will stop immediately.
Governing Law
These Terms are governed by and interpreted in accordance with the laws of the Arab Republic of Egypt, without regard to conflict of law principles.
If any provision is found to be invalid or unenforceable, the remaining provisions will remain in full effect.
These Terms represent the complete agreement between you and Best Fortune Teller Egypt and replace any prior agreements regarding the Service.
Changes to Terms
We may update or modify these Terms at any time at our sole discretion. Continued use of the Service after such changes indicates your acceptance of the updated Terms.
Contact
If you have any questions about these Terms, please contact us:
Email: contact@bft-eg.com 
Website: https://bft-eg.com
© 2026 Best Fortune Teller Egypt. All rights reserved.
`,
    January: "January",
    February: "February",
    March: "March",
    April: "April",
    May: "May",
    June: "June",
    July: "July",
    August: "August",
    September: "September",
    October: "October",
    November: "November",
    December: "December",
    Logout: "Log Out",
    Login: "Login",
    Unsubscribe: "Unsubscribe",
    UnsubSuccess: "You have been unsubscribed successfully",
    UnsubFail: "Fail to unsubscribe",
    Subscribe: "Subscribe",
    Confirm: "Confirm",
    notSubscribed: "You do not have subscription ?",
    resendOtp: "Resend pin code",
    selectRegion: "Select your region:",
  },
};

export default en;
